import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { take, tap } from 'rxjs';
import { SubSink } from 'subsink';
import { ParametersFacade } from '@facades/parameters.facade';
import { AuthFacade } from '@root/src/app/facades/auth.facade';

export interface IList {
	orderId: number;
	total: number;
	orderNumber: number;
}

@Component({
	selector: 'app-unread-order-msgs-panel',
	templateUrl: './unread-order-msgs-panel.component.html',
	styleUrls: ['./unread-order-msgs-panel.component.scss'],
})
export class UnreadOrderMsgsPanelComponent {
	private subs = new SubSink();
	profileId!: number;
	@Input() list: IList[] = [];
	@Output() clickOpenMsgsEvent = new EventEmitter<void>();

	constructor(
		private _router: Router,
		private authFacade: AuthFacade,
		private parametersFacade: ParametersFacade
	) {
		this.subs.add(
			this.authFacade.authState$.pipe(take(1)).subscribe(({ user }) => {
				if (user?.profileId) {
					this.profileId = user?.profileId;
				}
			})
		);
	}

	private get parameters() {
		return this.parametersFacade.parameters;
	}

	openMsgs(orderId: number) {
		this.clickOpenMsgsEvent.emit();

		let url = '';

		// Cliente
		if (this.profileId === 1 || this.profileId === 2) {
			url = `/account/orders/${orderId}`;
		}

		// Adm/Vendedor
		if (this.profileId === 3 || this.profileId === 5) {
			url = `/dashboard/orders/${orderId}`;
		}

		return this._router.navigate([url]);
	}
}
